import { __decorate } from "tslib";
import { Component, Vue, Ref } from 'vue-property-decorator';
import BaseSetting from './components/base-setting.vue';
import ChangePassword from './components/change-password.vue';
import Notification from './components/notification.vue';
import privacyMode from './components/privacy-mode.vue';
let default_1 = class default_1 extends Vue {
    personal;
    tabPosition = 'top';
    activeTab = 'first';
    // tableHeight: number = 0;
    mounted() {
        // this.tableHeight = this.personal.clientHeight - 58;
    }
};
__decorate([
    Ref()
], default_1.prototype, "personal", void 0);
default_1 = __decorate([
    Component({
        name: 'personal',
        components: {
            BaseSetting,
            ChangePassword,
            Notification,
            privacyMode,
        },
        i18n: {
            messages: {
                'en-us': {
                    basicSettings: 'basic settings',
                    privacyMode: 'Privacy mode',
                    changePassword: 'change password',
                    notification: 'notification',
                },
                zh: {
                    basicSettings: '基本设置',
                    privacyMode: '隐私安全',
                    changePassword: '修改密码',
                    notification: '消息通知',
                },
            },
        },
    })
], default_1);
export default default_1;
